// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firestore: {
    apiKey: 'AIzaSyD7y6JTzHLdsP6-tGurav8cAWc5HVY2jFY',
    authDomain: 'aigens-realtime-test.firebaseapp.com',
    databaseURL: 'https://aigens-realtime-test.firebaseio.com',
    projectId: 'aigens-realtime-test',
    storageBucket: 'aigens-realtime-test.appspot.com',
    messagingSenderId: '254840459819'
  },
  firebase: {
    apiKey: 'AIzaSyALcDXdd4tT5IAX4wA1ZVoeI3mJELf-Ypg',
    authDomain: 'aigensstoretest.firebaseapp.com',
    databaseURL: 'https://aigensstoretest.firebaseio.com',
    projectId: 'aigensstoretest',
    storageBucket: 'aigensstoretest.appspot.com',
    messagingSenderId: '254840459819'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
